// Plain-name Workspace app refs in the Automate prompt. Clicking an icon
// inserts or removes the app name at the caret; highlights follow the text.
// The matching and caret work is shared with the sheet graphic — see
// lib/prompt_terms.js.

import { findTermMatches, insertTerm, removeTerm } from './prompt_terms';

export const WORKSPACE_APPS = [
  { id: 'gmail', label: 'Gmail', aliases: ['email'] },
  {
    id: 'chat',
    label: 'Google Chat',
    aliases: ['chat', 'gchat', 'hangouts', 'hangout']
  },
  {
    id: 'calendar',
    label: 'Google Calendar',
    // Short name plus common misspellings of "calendar".
    aliases: ['calendar', 'calender', 'calandar', 'calander', 'cal']
  },
  { id: 'tasks', label: 'Google Tasks', aliases: ['tasks', 'gtasks'] },
  { id: 'docs', label: 'Google Docs', aliases: ['docs', 'doc', 'gdoc'] },
  { id: 'slides', label: 'Google Slides', aliases: ['slides', 'slide', 'gslide'] },
  { id: 'sites', label: 'Google Sites', aliases: ['sites', 'site', 'gsite', 'gsites'] },
  { id: 'keep', label: 'Google Keep', aliases: ['keep', 'gkeep'] },
  { id: 'forms', label: 'Google Forms', aliases: ['forms', 'form', 'gforms'] },
  { id: 'drive', label: 'Google Drive', aliases: ['drive', 'gdrive'] }
];

function matchTerms(app) {
  return [app.label, ...(app.aliases || [])];
}

export function appsPresentInText(text) {
  const present = new Set();
  for (const app of WORKSPACE_APPS) {
    if (findTermMatches(text, matchTerms(app)).length) present.add(app.id);
  }
  return present;
}

// Inserts the plain app name at the caret, with spaces so it does not stick to
// nearby words. Returns the new value.
export function insertAppRef(textarea, label) {
  return insertTerm(textarea, label);
}

// Removes one occurrence of the app label or any alias (any casing). Prefers
// the match nearest the caret; otherwise the first match.
export function removeAppRef(textarea, label) {
  const app = WORKSPACE_APPS.find((entry) => entry.label === label);
  return removeTerm(textarea, app ? matchTerms(app) : [label]);
}
